import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=c4bfade2&scoped=true&"
var script = {}
import style0 from "./refund.vue?vue&type=style&index=0&id=c4bfade2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bfade2",
  null
  
)

export default component.exports